import React from 'react';
import { Layout } from '../components/Layout';
export function TermsPage() {
  return <Layout data-id="element-535">
      <div className="py-16 px-6 bg-alabaster border-b-3 border-charcoal" data-id="element-536">
        <div className="max-w-7xl mx-auto" data-id="element-537">
          <h1 className="text-6xl md:text-8xl font-bold mb-8" data-id="element-538">
            Terms of <br data-id="element-539" />
            <span className="italic font-serif font-normal text-espresso" data-id="element-540">
              Service
            </span>
          </h1>
          <p className="text-xl text-charcoal/60 max-w-2xl leading-relaxed" data-id="element-541">
            Guidelines for using our services.
          </p>
        </div>
      </div>
      <section className="py-16 px-6 bg-white" data-id="element-542">
        <div className="max-w-4xl mx-auto prose prose-charcoal" data-id="element-543">
          <h2 className="text-3xl font-bold mb-6" data-id="element-544">1. Acceptance of Terms</h2>
          <p className="mb-8 text-charcoal/70 leading-relaxed" data-id="element-545">
            By using our services, you agree to these Terms and all applicable
            laws.
          </p>

          <h2 className="text-3xl font-bold mb-6" data-id="element-546">2. Scope of Services</h2>
          <p className="mb-8 text-charcoal/70 leading-relaxed" data-id="element-547">
            We provide cabinet refacing, consultation, and installation. Project
            details are outlined in your contract.
          </p>

          <h2 className="text-3xl font-bold mb-6" data-id="element-548">3. Estimates and Pricing</h2>
          <p className="mb-8 text-charcoal/70 leading-relaxed" data-id="element-549">
            All quotes provided via our website or in-home surveys are estimates
            based on the information available at the time. Final pricing is
            subject to a formal site inspection and signed agreement.
          </p>

          <h2 className="text-3xl font-bold mb-6" data-id="element-550">4. Intellectual Property</h2>
          <p className="mb-8 text-charcoal/70 leading-relaxed" data-id="element-551">
            All site content is property of NK Home Improvement and protected by
            copyright.
          </p>
        </div>
      </section>
    </Layout>;
}